import { Card, CardContent } from '@/components/ui/card';
import { targetProfessions } from '@/data/sponsor/targetProfessions';
import { BriefcaseIcon, HomeIcon, ShieldCheckIcon, ScaleIcon, WrenchScrewdriverIcon, KeyIcon } from '@heroicons/react/24/outline';

const TargetProfessionsSection = () => {
  const icons = [BriefcaseIcon, HomeIcon, KeyIcon, ShieldCheckIcon, ScaleIcon, WrenchScrewdriverIcon];

  return (
    <div className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
            Built for Professionals Serving Aging Clients
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            If your clients want to age safely and independently at home, SeniorThrive becomes part of your advisory toolkit.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {targetProfessions.map((profession, index) => {
            const Icon = icons[index] || BriefcaseIcon;
            return (
              <Card key={index} className="border-border/50 hover:border-primary/20 transition-colors">
                <CardContent className="p-6 text-center">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <h4 className="font-bold text-foreground">
                    {profession.title}
                  </h4>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TargetProfessionsSection;
